/** Australian mobile number helpers: normalise to E.164 (+61…) and format for display. */

/** Strip everything except digits, drop +61 / 61 / leading 0 prefixes. Returns national digits (9 max, starts with 4 or 5). */
export function toNationalDigits(raw: string): string {
  let d = raw.replace(/\D/g, "");
  if (d.startsWith("0061")) d = d.slice(4);
  if (d.startsWith("61") && d.length > 9) d = d.slice(2);
  if (d.startsWith("0")) d = d.replace(/^0+/, "");
  return d.slice(0, 9);
}

/** Pretty display grouping: 412 345 678 */
export function formatAuMobile(raw: string): string {
  const d = toNationalDigits(raw);
  const parts = [d.slice(0, 3), d.slice(3, 6), d.slice(6, 9)].filter(Boolean);
  return parts.join(" ");
}

/** Valid AU mobile: 9 national digits beginning with 4 or 5. */
export function isValidAuMobile(raw: string): boolean {
  const d = toNationalDigits(raw);
  return /^[45]\d{8}$/.test(d);
}

/** E.164 for storage/tracking: +61412345678. Empty string when invalid. */
export function toE164AuMobile(raw: string): string {
  return isValidAuMobile(raw) ? `+61${toNationalDigits(raw)}` : "";
}

export const AU_MOBILE_ERROR = "Please enter a valid Australian mobile number.";
